import React, { useState } from "react";
import "../../css/Insurance.css";
import Toggle from "./Toggle";

const Insurance = ({ data, onChange }) => {
  const handleInputChange = (field, value) => {
    onChange(field, value);
  };
  

  const renderForm = () => (
    <div className="insurance-form">
      <div className="form-group">
        <label>Imię z dowodu *</label>
        <input
          type="text"
          value={data?.firstName || ''}
          onChange={(e) => handleInputChange("firstName", e.target.value)}
          placeholder="Wpisz imię"
          required
        />
      </div>
      <div className="form-group">
        <label>Nazwisko z dowodu *</label>
        <input
          type="text"
          value={data?.lastName || ''}
          onChange={(e) => handleInputChange("lastName", e.target.value)}
          placeholder="Wpisz nazwisko"
          required
        />
      </div>
      <div className="form-group">
        <label>Data urodzenia *</label>
        <input
          type="date"
          value={data?.birthDate || ''}
          onChange={(e) => handleInputChange("birthDate", e.target.value)}
          required
        />
      </div>
      <div className="form-group">
      <Toggle label="Osoba przewlekle chora?" 
            checked={data?.isChronicIllness || false}
            onChange={(e) => handleInputChange("isChronicIllness", e.target.checked)}/>
      </div>
    </div>
  );

  return (
    <div className="insurance-container">
      {renderForm()}
    </div>
  );
};

export default Insurance;
